export const BR = 'br'
export const GE = 'ge'
export const PARAM_REQUEST_AMOUNT = 'requestAmount'
